import { Stack } from 'expo-router';

export default function GroceryListsLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="manage-staples" />
    </Stack>
  );
}
